import { AxiosError } from '@src/helpers/httpClient'
import { DefaultState } from '@src/redux/types'

import {
  ASSESSMENT_AMENDMENT,
  ASSESSMENT_AMENDMENT_ALL,
  ASSESSMENT_AMENDMENT_ALL_UPDATED,
  ASSESSMENT_AMENDMENT_CREATE,
  ASSESSMENT_AMENDMENT_DELETE,
  ASSESSMENT_AMENDMENT_LIST,
  ASSESSMENT_AMENDMENT_PUBLISH,
  ASSESSMENT_MARKS_GENERATE,
  ASSESSMENT_MARK_STATUS,
  ASSESSMENT_ZIP_UPLOADS,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [ASSESSMENT_AMENDMENT]: DefaultState<`${typeof API.ASSESSMENT_AMENDMENT}{id}`, 'get'>
  [ASSESSMENT_AMENDMENT_ALL]: DefaultState<`${typeof API.ASSESSMENT_AMENDMENT_ALL}`, 'get'>
  [ASSESSMENT_AMENDMENT_ALL_UPDATED]: DefaultState<`${typeof API.ASSESSMENT_AMENDMENT_ALL_UPDATED}`, 'get'>
  [ASSESSMENT_AMENDMENT_CREATE]: DefaultState<`${typeof API.ASSESSMENT_AMENDMENT}`, 'post'>
  [ASSESSMENT_AMENDMENT_DELETE]: DefaultState<`${typeof API.ASSESSMENT_AMENDMENT}{id}`, 'delete'>
  [ASSESSMENT_AMENDMENT_LIST]: DefaultState<`${typeof API.ASSESSMENT_AMENDMENT}`, 'get'>
  [ASSESSMENT_AMENDMENT_PUBLISH]: DefaultState<`${typeof API.ASSESSMENT_AMENDMENT_PUBLISH}`, 'put'>
  [ASSESSMENT_MARK_STATUS]: DefaultState<`${typeof API.ASSESSMENT_MARK_CHANGE_STATUS}`, 'put'>
  [ASSESSMENT_MARKS_GENERATE]: DefaultState<`${typeof API.ASSESSMENT_MARKS_GENERATE}`, 'get'>
  [ASSESSMENT_ZIP_UPLOADS]: DefaultState<`${typeof API.ASSESSMENT_ZIP_UPLOADS}`, 'get'>
} = () => ({
  [ASSESSMENT_AMENDMENT]: defaultState(),
  [ASSESSMENT_AMENDMENT_ALL]: defaultState(),
  [ASSESSMENT_AMENDMENT_ALL_UPDATED]: defaultState(),
  [ASSESSMENT_AMENDMENT_CREATE]: defaultState(),
  [ASSESSMENT_AMENDMENT_DELETE]: defaultState(),
  [ASSESSMENT_AMENDMENT_LIST]: defaultState(),
  [ASSESSMENT_AMENDMENT_PUBLISH]: defaultState(),
  [ASSESSMENT_MARK_STATUS]: defaultState(),
  [ASSESSMENT_MARKS_GENERATE]: defaultState(),
  [ASSESSMENT_ZIP_UPLOADS]: defaultState(),
})
